const escapeHtml = (value) =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

/**
 * @param {{ name: string, href?: string }[]} items — уровни после «Главная»
 */
module.exports = (items = []) => {
  const crumbs = [{ name: "Главная", href: "/" }, ...items];

  const listItems = crumbs
    .map((item, index) => {
      const isLast = index === crumbs.length - 1;
      const name = escapeHtml(item.name);
      const inner =
        isLast || !item.href
          ? `<span class="breadcrumbs__link" title="${name}" itemprop="item">
				<meta itemprop="position" content="${index}" />
				<span itemprop="name">${name}</span>
			</span>`
          : `<a class="breadcrumbs__link" title="${name}" itemprop="item" href="${escapeHtml(item.href)}">
				<meta itemprop="position" content="${index}" />
				<span itemprop="name">${name}</span>
			</a>`;

      return `<li class="breadcrumbs__item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
			${inner}
		</li>`;
    })
    .join("\n\t\t");

  return `<div class="breadcrumbs">
	<ul class="breadcrumbs__list" itemscope itemtype="https://schema.org/BreadcrumbList" aria-label="Хлебные крошки">
		${listItems}
	</ul>
</div>`;
};
